import React, { useEffect, useRef, useState } from 'react';
import type { FC } from 'react';
import classnames from 'classnames';
import styles from './resortList.mobile.module.css';

// Icon:
import Icon from '../../../../../../components/Icon';
import type { IResortList } from './Models/resort-list.model';

interface Props {
  className?: string;
  lists: IResortList[];
  linkedResortListTitle: string;
}

export const ResortListMobile: FC<Props> = (props) => {
  const { className, lists, linkedResortListTitle } = props;

  const [showAll, setShowAll] = useState(false);
  const handleShowMore = () => setShowAll(!showAll);
  const showMoreLabel = 'Показать все курорты';

  const containerRef = useRef<HTMLDivElement>(null);
  const [overflown, setOverflown] = useState(false);
  useEffect(() => {
    const isOverflown =
      lists.length +
        lists.reduce((acc, curr) => acc + curr.elements.length, 0) >
      6;
    setOverflown(isOverflown);
  }, [showAll]);

  const dummy: any = {};

  return (
    <div className={classnames(className, styles.wrapper)}>
      <div
        className={classnames(styles.list, {
          [styles.listShowAll]: showAll,
          [styles.listOverflown]: overflown,
        })}
        ref={containerRef}
      >
        <h2 className={styles.title}>{linkedResortListTitle}</h2>
        {lists.map((list) => {
          const { name, elements } = list;
          if (!Array.isArray(elements) || !elements.length) return null;
          return (
            <>
              <p className={styles.name}>{name}</p>
              {elements.map((item) => {
                const { link, text } = item;

                return (
                  <div className={styles.listItem} key={`${link}`}>
                    <a className={styles.anchor} href={link}>
                      {text}
                    </a>
                  </div>
                );
              })}
            </>
          );
        })}
      </div>
      {!showAll ? (
        <button
          className={styles.showMore}
          type="button"
          onClick={handleShowMore}
        >
          {showMoreLabel}
          <Icon type="arrow-down" {...dummy} />
        </button>
      ) : null}
    </div>
  );
};
